import React from 'react';

import FocusTrap from 'focus-trap-react';
import PropTypes from 'prop-types';

import modal from './modal.scss';

export const Modal = ({
    onClose,
    onKeyDown,
    children,
    contentClassName,
}) => (
    <FocusTrap active>
        <div id="myModal" className={modal['ml-modal']} onKeyDown={onKeyDown}>
            <div className={modal['outer-ml-modal']}>
                <div
                    className={`${modal['ml-modal-content']}
                    ${contentClassName}`}
                >
                    <div className={modal['ml-modal-header']}>
                        <span
                            className="close-icon"
                            onClick={onClose}
                        >
                            <img src="/img/icons/black_close.svg" width={32} height={32} alt="x" tabIndex={0} />
                        </span>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    </FocusTrap>
);

Modal.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    contentClassName: PropTypes.string,
};

Modal.deafultProps = {
    contentClassName: '',
};

export default Modal;
